<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FazendaModule',
  }
</script>
